/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewtitle2Inputs */

const en_letterpreviewtitle2 = /** @type {(inputs: Letterpreviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your letter`)
};

const pt_letterpreviewtitle2 = /** @type {(inputs: Letterpreviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua carta`)
};

/**
* | output |
* | --- |
* | "Your letter" |
*
* @param {Letterpreviewtitle2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewtitle2 = /** @type {((inputs?: Letterpreviewtitle2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewtitle2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewtitle2(inputs)
	return pt_letterpreviewtitle2(inputs)
});
export { letterpreviewtitle2 as "letterPreviewTitle" }